import superFetch from '../../utils/super-fetch';

const url = '/broker-verification/bounds';

// Default, safe empty shape used both as the pre-fetch/flag-off state and as the
// fail-open fallback on any fetch error (BR-F8, NFR-2).
const DEFAULT_BOUNDS = {
  baseRent: null,
  fieldBounds: {},
  missingRequiredFields: [],
};

/**
 * Fetches the combined broker-verification bounds/required-fields response for the
 * Review page. Never rejects — on any network error, non-2xx response, or malformed
 * payload, resolves to `DEFAULT_BOUNDS` plus `failed: true` instead (fail-open for range
 * warnings; callers that route on it can tell a failure from "no bounds").
 * @param {{edpPropertyId?: string, fieldValues?: Object}} params
 * @returns {Promise<{baseRent: Object|null, fieldBounds: Object, missingRequiredFields: Array, failed?: boolean}>}
 */
const fetchBrokerVerificationBounds = ({ edpPropertyId, fieldValues } = {}) => {
  const options = {
    method: 'GET',
    params: {
      edp_property_id: edpPropertyId,
      field_values: fieldValues ? JSON.stringify(fieldValues) : undefined,
    },
  };
  return superFetch(url, options)
    .then(data => data.json())
    .then(data => ({ ...DEFAULT_BOUNDS, ...data }))
    .catch(() => ({ ...DEFAULT_BOUNDS, failed: true }));
};

export {
  fetchBrokerVerificationBounds,
  DEFAULT_BOUNDS,
};
